import InfoIcon from '@mui/icons-material/Info';
import {styled} from '@mui/material/styles'

import Tooltip, {tooltipClasses, TooltipProps} from '@mui/material/Tooltip';
import parse from 'html-react-parser'
import useGfmToHtml from "../hooks/useGfmToHtml";

interface DisplayTextComponentProps {
    text: string;
    hint?: string;
    required?: boolean;
}

const DisplayTextTooltip = styled(({className, ...props}: TooltipProps) => (
        <Tooltip {...props} arrow classes={{popper: className}}/>
))(({theme}) => {
    return ({
        [`& .${tooltipClasses.arrow}`]: {
            color: theme.palette.common.black,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.black,
            fontSize: 13
        }
    })
});
const DisplayTextComponent: React.FC<DisplayTextComponentProps> =
        ({text, hint, required = false}) => {
            const displayText = useGfmToHtml(text);

            return <div style={{display: "flex", alignItems: "center", gap: hint ? 5 : 0, position: 'relative'}}>
            <span style={{
                display: "inline-block",
                maxWidth: "100%",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal"
            }}>
                
            {parse(displayText)}
            </span>
                <span style={{marginLeft: hint ? -2 : 3}}>
                {required ? " *" : ""}
            </span>
                {
                        hint
                        &&
                        <DisplayTextTooltip
                                title={hint}
                                color={"primary"}
                                arrow
                                style={{position: 'absolute', top: -2, right: -15}}>
                            <InfoIcon fontSize={"small"} style={{cursor: "pointer", marginBottom: 2}}/>
                        </DisplayTextTooltip>
                }
            </div>
        };

export default DisplayTextComponent;